import * as React from 'react'

export interface HammerPriceProps {
    /**
     * This allows to pass a custom className to the component.
     * i.e. className="js_TrackIcon", which is used for Google Analytics.
     */
    className?: string
    title?: string
}

export const HammerPriceIcon = ({
    className = 'js_HammerPriceIcon',
    title,
}: HammerPriceProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 13 16"
            fill="none"
            height={16}
            className={className}
        >
            {title && <title>{title}</title>}
            <path
                d="M5.76 10V7.68H7.928V10H9.136V4.4H7.928V6.664H5.76V4.4H4.552V10H5.76Z"
                fill="black"
            />
            <circle cx="6.5" cy="7.5" r="6" stroke="black" />
        </svg>
    )
}
